// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-confirmed-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
        master: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({}),
    // #endregion
    // #region Core
    methods: {
        gotoHome() {
            this.$router.push({ path: "/ozg" });
        },
        onCommand(command, args) {
            //Init
            this._isWorking = true;
            //Run
            this.$emit('command', command, args, () => { this._isWorking = false; });
        },
    },
    // #endregion
});
// #endregion
